import { fallbackLanguage, type Language, loadTranslations } from '$lib/i18n/translation';
import type { Load } from '@sveltejs/kit';
import { marked } from 'marked';

export const load: Load = async ({ url, data }) => {
	marked.setOptions({ breaks: true, gfm: true });
	const { pathname } = url;

	const initLanguage: Language = data?.displayLanguage || fallbackLanguage.code;

	await loadTranslations(initLanguage.code, pathname);

	return data;
};
